// extracted by mini-css-extract-plugin
export var link = "login-module--link--afde6";
export var link__light = "login-module--link__light--aac88";
export var login = "login-module--login--416b6";
export var spin = "login-module--spin--04282";